// Static Mobile Menu JavaScript
(function() {
  // Check if we're on iOS
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const mobileMenuParentDiv = document.querySelector('#static-mobile-menu_parent');
  document.addEventListener('DOMContentLoaded', function() {
    // mobileMenuParentDiv.style.display = 'block';
    mobileMenuParentDiv.removeAttribute('style');
  });

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Static Mobile Menu: Initializing');

    // For iOS, ensure all submenu panels are initially hidden
    if (isIOS) {
      console.log('Static Mobile Menu: Hiding all submenu panels on iOS');
      const allSubmenuPanels = document.querySelectorAll('.static-mobile-menu__submenu-panel');
      allSubmenuPanels.forEach(function(panel) {
        panel.classList.remove('active');
      });
    }

    // Get the mobile menu toggle button
    const mobileMenuToggle = document.querySelector('.mobileMenu-toggle');
    const staticMobileMenu = document.querySelector('.static-mobile-menu');
    const staticMobileMenuClose = document.querySelector('.static-mobile-menu__close');
    const backgroundOverlay = document.querySelector('.background-overlay');

    if (!mobileMenuToggle || !staticMobileMenu || !staticMobileMenuClose || !backgroundOverlay) {
      console.log('Static Mobile Menu: Missing required elements');
      return;
    }

    console.log('Static Mobile Menu: Found all required elements');

    // For iOS, we need to replace the toggle button to remove any existing event listeners
    if (isIOS) {
      console.log('Static Mobile Menu: iOS detected, replacing toggle button');
      const newMobileMenuToggle = mobileMenuToggle.cloneNode(true);
      mobileMenuToggle.parentNode.replaceChild(newMobileMenuToggle, mobileMenuToggle);

      // Update the reference to the new button
      const mobileMenuToggleUpdated = document.querySelector('.mobileMenu-toggle');

      // Toggle menu when clicking the hamburger button (iOS specific)
      mobileMenuToggleUpdated.addEventListener('click', function(event) {
        console.log('Static Mobile Menu: Toggle button clicked (iOS)');
        event.preventDefault();
        event.stopPropagation();

        // Toggle the menu_open class
        document.body.classList.toggle('menu_open');

        // Force reflow to ensure proper rendering on iOS
        void staticMobileMenu.offsetHeight;

        // Add hardware acceleration class
        staticMobileMenu.classList.add('ios-hardware-accelerated');

        // Ensure the menu is visible
        if (document.body.classList.contains('menu_open')) {
          console.log('Static Mobile Menu: Opening menu (iOS)');

          // // Force iOS to render the menu properly
          // setTimeout(function() {
          //   console.log('Static Mobile Menu: Forcing reflow (iOS)');
          //   staticMobileMenu.style.display = 'none';
          //   void staticMobileMenu.offsetHeight;
          //   staticMobileMenu.style.display = '';
          // }, 50);
        }
      });
    } else {
      // // Toggle menu when clicking the hamburger button (non-iOS)
      // mobileMenuToggle.addEventListener('click', function(event) {
      //   console.log('Static Mobile Menu: Toggle button clicked');
      //   event.preventDefault();
      //   event.stopPropagation();
      //   document.body.classList.toggle('menu_open');
      // });

      // Toggle menu when clicking the hamburger button (non-iOS)
      mobileMenuToggle.addEventListener('click', function(event) {
        console.log('Static Mobile Menu: Toggle button clicked');
        event.preventDefault();
        event.stopPropagation();
      
        if (!document.body.classList.contains('menu_open')) {
          // Show menu and trigger transition on next frame
          requestAnimationFrame(() => {
            document.body.classList.add('menu_open');
          });
        } else {
          document.body.classList.remove('menu_open');
        }
      });
      
    }

    // Close menu when clicking the close button
    staticMobileMenuClose.addEventListener('click', function() {
      console.log('Static Mobile Menu: Close button clicked');
      document.body.classList.remove('menu_open');
    });

    // Close menu when clicking the background overlay
    backgroundOverlay.addEventListener('click', function() {
      console.log('Static Mobile Menu: Background overlay clicked');
      document.body.classList.remove('menu_open');
    });

    // Also close menu when clicking our custom overlay
    const staticMobileMenuOverlay = document.querySelector('.static-mobile-menu-overlay');
    if (staticMobileMenuOverlay) {
      staticMobileMenuOverlay.addEventListener('click', function() {
        console.log('Static Mobile Menu: Custom overlay clicked');
        document.body.classList.remove('menu_open');
      });
    }

    // Handle submenu panel navigation
    const submenuTriggers = document.querySelectorAll('[data-submenu-trigger]');
    const backButtons = document.querySelectorAll('[data-submenu-back]');

    // Open submenu panel when clicking a trigger
    submenuTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        console.log('Static Mobile Menu: Submenu trigger clicked');
        event.preventDefault();
        event.stopPropagation();

        const targetId = trigger.getAttribute('data-target');
        const targetPanel = document.getElementById(targetId);

        if (targetPanel) {
          console.log('Static Mobile Menu: Opening submenu panel', targetId);
          targetPanel.classList.add('active');

          // Force reflow for iOS
          if (isIOS) {
            void targetPanel.offsetHeight;
            targetPanel.classList.add('ios-hardware-accelerated');
          }
        }
      });

      // Also make the parent link trigger the submenu
      const parentLink = trigger.closest('.static-mobile-menu__link');
      if (parentLink) {
        parentLink.addEventListener('click', function(event) {
          if (parentLink.querySelector('[data-submenu-trigger]')) {
            event.preventDefault();
            event.stopPropagation();
            trigger.click();
          }
        });
      }
    });

    // Go back when clicking a back button
    backButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        console.log('Static Mobile Menu: Back button clicked');
        event.preventDefault();

        const panel = button.closest('[data-submenu-panel]');
        if (panel) {
          panel.classList.remove('active');

          // If this panel has a parent panel, open it
          const parentId = button.getAttribute('data-parent');
          if (parentId) {
            const parentPanel = document.getElementById(parentId);
            if (parentPanel) {
              parentPanel.classList.add('active');
            }
          }

          // Force reflow for iOS
          if (isIOS) {
            void panel.offsetHeight;
          }
        }
      });
    });

    // For iOS, we need to add touch events to ensure proper handling
    if (isIOS) {
      console.log('Static Mobile Menu: Adding iOS-specific touch events');

      // Add touch events to all links
      const allLinks = staticMobileMenu.querySelectorAll('a');
      allLinks.forEach(function(link) {
        link.addEventListener('touchstart', function() {
          console.log('Static Mobile Menu: Link touched');
          this.classList.add('ios-touched');
        }, { passive: true });

        link.addEventListener('touchend', function() {
          console.log('Static Mobile Menu: Link touch ended');
          this.classList.remove('ios-touched');
        }, { passive: true });
      });
    }
  });
})();
